import User from '@core/models/user/User';
import {
    NonFinalConfig,
    PopularAccasConfig,
    TopWinnersConfig,
} from '@core/services/offerPresentation/OfferPresentationService';
import { CustomMarketGroup } from '@modules/eventGrid/components/MarketLayouts/MarketLayoutTypes';

export const TOP_WINNERS_TABS = {
    DAILY: 'daily',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
} as const;

export type TopWinnersTabs = typeof TOP_WINNERS_TABS[keyof typeof TOP_WINNERS_TABS];

export type MarketsState = {
    selectedMarketGroupId: number | null;
    marketLayoutsConfig?: CustomMarketGroup[];
    marketLayouts: CustomMarketGroup[];
    hasSetMarketLayouts: boolean;
    marketLayoutsUserId?: User['userId'];
    nonFinalMarketsConfig?: NonFinalConfig;
    popularAccasConfig?: PopularAccasConfig;
    topWinnersConfig?: TopWinnersConfig;
    topWinnersSelectedTab: TopWinnersTabs;
};
